import { jsx as _jsx } from "react/jsx-runtime";
import { Chip, Typography, useTheme } from "@mui/material";
export const SubsStatusChip = ({ currentSubscriptionStatus }) => {
    var _a, _b;
    const theme = useTheme();
    const CHIP_COLORS = {
        Active: { backgroundColor: theme.palette.success.light, color: theme.palette.success.contrastText },
        Paused: { backgroundColor: theme.palette.info.light, color: theme.palette.info.contrastText },
        Cancelled: { backgroundColor: theme.palette.error.light, color: theme.palette.error.contrastText },
        Complete: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.getContrastText(theme.palette.common.black),
        },
        None: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.getContrastText(theme.palette.common.black),
        },
    };
    return (_jsx(Chip, { size: "medium", label: _jsx(Typography, Object.assign({ variant: "body1" }, { children: currentSubscriptionStatus })), variant: "filledSquared", sx: {
            backgroundColor: (_a = CHIP_COLORS[currentSubscriptionStatus]) === null || _a === void 0 ? void 0 : _a.backgroundColor,
            color: (_b = CHIP_COLORS[currentSubscriptionStatus]) === null || _b === void 0 ? void 0 : _b.color,
        } }));
};
